/**
 * 默认的 i18n 文案配置
 */
export var defaultI18nConfig = {
    common: {},
    core: {
        // Internal Error
        ERROR_MSG_UNKNOWN: '未知错误',
        ERROR_XHR_NET: '视频获取途中出现问题',
        ERROR_PRELOAD_VIDEO_TIMEOUT: '加载视频超时',
        ERROR_INNER: '视频无法继续播放',
        ERROR_LOAD_STREAM_FAIL: '视频流获取途中出现问题',
        ERROR_PLAY_STUCK: '播放缓冲出错',
        ERROR_NULL_URL: '传入的地址为空',
        // <video/> Error
        ERROR_MEDIA_ERR_ABORTED: '视频获取被终止',
        ERROR_MEDIA_ERR_NETWORK: '下载视频发生错误',
        ERROR_MEDIA_ERR_DECODE: '尝试解码出错',
        ERROR_MEDIA_ERR_SRC_NOT_SUPPORTED: '浏览器不支持该音视频',
        // KernelProxy Error
        ERROR_KERNEL_NOT_FOUND: '切换清晰度时找不到对应内核',
        // check-player-status.ts
        ERROR_STATUS_NOT_INITIALIZED: '播放器尚未初始化',
        ERROR_STATUS_NOT_PLAYING: '播放未开始',
        ERROR_STATUS_EMPTY_URL: '切换目标视频地址为空',
        ERROR_STATUS_VIDEO_INFO: '找不到当前播放信息',
        ERROR_STATUS_PLAYTIME_CHECK: '播放未开始',
        ERROR_STATUS_CLOSE_TO_END: '播放即将结束',
        ERROR_STATUS_TARGET_UNCHANGED: '切换的视频地址没有变化',
        // DRM
        ERROR_DRM_UNKNOWN: '未知错误',
        ERROR_DRM_LICENSE_NOT_EXIST: '视频资源已加密，但未配置解密证书地址',
        ERROR_DRM_KEY_SYS_NOT_REQUESTED: '视频资源已加密，但尚未请求CDM',
        ERROR_DRM_KEY_NOT_EXIST: '视频资源已加密，但尚未获取到MediaKey',
        ERROR_DRM_KEY_SESSION_NOT_EXIST: '视频资源已加密，但CDM',
        ERROR_DRM_INIT_DATA_EMPTY: '视频资源已加密，但事件信息中没有用于创建请求的 initData',
        ERROR_DRM_KEY_SESSION_REQUEST_FAILED: '视频资源已加密，但 CDM Session 请求失败',
        ERROR_DRM_KEY_SYS_NOT_SUPPORTED: '$0 不支持',
        ERROR_DRM_KEY_SYS_ACCESS_FAILED: '访问CDM失败, keySystem $0',
        ERROR_DRM_KEY_SESSION_CREATION_FAILED: 'CDM Session 初始化失败',
        ERROR_DRM_HDCP: '你可能链接了不支持HDCP标准的显示器',
        ERROR_DRM_KEY_INTERNAL: '内部错误',
        ERROR_DRM_KEY_EXPIRED: 'MediaKey 已过期',
        ERROR_DRM_KEY_RELEASED: 'MediaKey 已从CDM中注销',
        ERROR_DRM_MEDIA_KEYS_SET_FAILED: 'failed to set media keys',
        ERROR_DRM_KEY_SESSION_UPDATE_FAILED: 'CDM Session 更新失败，请检查证书解析',
        ERROR_DRM_LICENSE_REQUEST_FAILED: '证书请求失败 $0',
        ERROR_DRM_FPS_SET_KEY_FAILED: 'Webkit MediaKey创建失败',
        ERROR_DRM_FPS_CERTIFICATE_NOT_EXIST: '视频资源已加密，但 Fairplay 服务端证书未配置',
        // Audio Effect
        INFO_AUDIO_EFFECT_DEFAULT: '默认音效',
        INFO_AUDIO_EFFECT_SPATIAL_STEREO: '环绕立体声',
        INFO_AUDIO_EFFECT_BASE_BOOSTER: '重低音',
        INFO_AUDIO_EFFECT_VOCAL_BOOSTER: '强化人声',
        INFO_AUDIO_EFFECT_VOCAL_WEAK: '弱化人声',
        INFO_AUDIO_EFFECT_POP: '流行',
        INFO_AUDIO_EFFECT_CLASSICAL: '古典',
        INFO_AUDIO_EFFECT_ELECTRONIC: '电子音乐',
        INFO_AUDIO_EFFECT_GUITAR: '吉他',
        INFO_AUDIO_EFFECT_HIPHOP: '嘻哈',
        INFO_AUDIO_EFFECT_JAZZ: '爵士',
        INFO_AUDIO_EFFECT_RNB: 'R&B',
        INFO_AUDIO_EFFECT_ROCK_N_ROLL: '摇滚',
        INFO_AUDIO_EFFECT_CONCERT_HALL: '音乐厅',
        INFO_AUDIO_EFFECT_LIVE: '现场',
        INFO_AUDIO_EFFECT_LIVING_ROOM: '客厅',
    },
};
/**
 * i18n 文案配置，可通过文案字符串 / 文案生成函数来定制文案内容
 */
export var i18nConfig = defaultI18nConfig;
